type DaysSplit = {
  previousYearDaysUsedForRequest: number;
  currentYearDaysUsedForRequest: number;
};

const toNumber = (value: unknown): number | null => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

const pickFirstNumber = (...values: unknown[]): number => {
  for (const value of values) {
    const parsed = toNumber(value);
    if (parsed !== null) {
      return parsed;
    }
  }

  return 0;
};

export const resolvePdfDaysSplit = (payload: Record<string, unknown>): DaysSplit => {
  const previousYearDaysUsedForRequest = pickFirstNumber(
    payload.previousYearDaysUsedForRequest,
    payload.previous_year_days_used_for_request,
    payload.usedPreviousYearDays,
    payload.used_previous_year_days,
  );

  const currentYearDaysUsedForRequest = pickFirstNumber(
    payload.currentYearDaysUsedForRequest,
    payload.current_year_days_used_for_request,
    payload.usedCurrentYearDays,
    payload.used_current_year_days,
  );

  return {
    previousYearDaysUsedForRequest,
    currentYearDaysUsedForRequest,
  };
};
